import querystring from 'querystring';
import { setTrk } from '@nerdwallet/nw-client-lib/trk-helper';

import { getPageTaxonomy, getTaxonomyObject } from './page-taxonomy';

/**
 * Wrapper around setTrk that injects page taxonomy Object and base url
 * @param {string} fromRoutePath - path of current route, used to get page taxonomy
 * @param {string} toPath - path of destination
 * @param {Object=} options - options Object to be passed to setTrk, coupled to setTrk API
 * @param {Object=} options.nonTrkParams - params not for trk purposes (e.g. redirect_uri)
 * @param {Object=} options.trkParams - params to be passed to setTrk
 * @param {boolean=} options.isStub - stub param to be passed to setTrk
 */
function internalLink(fromRoutePath, toPath, options = {}) {
  // Keep nonTrkParams at the top level of the query
  const nonTrkQuery = querystring.stringify(options.nonTrkParams);
  return setTrk({
    url: `${toPath}?${nonTrkQuery}`,
    taxonomy: getTaxonomyObject(getPageTaxonomy(fromRoutePath)),
    params: options.trkParams,
    isStub: options.isStub,
  });
}

export default internalLink;
